import React from 'react'

import {
Stack,
Flex,
Button,
Text,
VStack,
useBreakpointValue,
Box,
} from '@chakra-ui/react';
import {useEffect} from 'react'
import Aos from 'aos'
import "aos/dist/aos.css"

export default function HeroCard() {

  useEffect(() => {
    Aos.init({duration:2000})
   
  }, [])


  return (
    <div data-aos="fade-right"
    data-aos-offset="500"
    data-aos-duration="500">
<h1 style={{textAlign:"center",fontSize:"50px",marginTop:"40px",marginBottom:"30px",overflow:"hidden"}} >Just For Motivation</h1>
    <Box style={{backgroundColor:"gray.100"}} overflow="hidden">
    <Flex
   
    mt={10}
    mb={10}
    w={'full'}
      h={'auto'}
      backgroundImage={
        'url(https://images.pexels.com/photos/696680/pexels-photo-696680.jpeg?auto=compress&cs=tinysrgb&w=600)'
    }
      backgroundSize={'cover'}
      backgroundPosition={'center center'}>
      <VStack
        w={'full'}
        justify={'center'}
        px={useBreakpointValue({ base: 4, md: 8 })}
        bgGradient={'linear(to-r, blackAlpha.600, transparent)'}>
        <Stack maxW={'2xl'} align={'flex-start'} spacing={6}>
          <Text
            color={'white'}
            p={"20px"}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: '3xl', md: '4xl' })}>
          
          "All Birds find shelter during rain. But Eagle avoids rain by flying above clouds"
          

          <Text>--By APJ APDUL KALAM</Text>
          </Text>
          <Text>

          And I want to be a Eagle like that 💟
          </Text>
          <Stack direction={'row'} p={"20px"}>
            <Button
              bg={'blue.400'}
              rounded={'full'}
              color={'white'}
              _hover={{ bg: 'blue.500' }}>
              Show more Quotes
            </Button>
            {/* <Button
              bg={'whiteAlpha.300'}
              rounded={'full'}
              color={'white'}
              _hover={{ bg: 'whiteAlpha.500' }}>
              Show me more
            </Button> */}
          </Stack>
        </Stack>
      </VStack>
    </Flex>
                  </Box>
            </div>
  );
  
}

